<div class="privacyPolicy__settings">
  <h3 class="vc-title-m privacyPolicy__settingsTitle" i18n="@@PRIVACY_POLICY.SETTINGS.TITLE">Set your cookies</h3>
  <p class="privacyPolicy__settingsDescription" i18n="@@PRIVACY_POLICY.SETTINGS.DESCRIPTION">
    Vestiaire Collective uses cookies for various purposes. Cookies allow us to offer you personalized content to make
    your online shopping as enjoyable as possible. Accept or decline the use of cookies.
  </p>

  <form id="formPrivacyPolicy__options" class="clearfix">
    <div class="vc-form-checkbox-switch">
      <input
        type="checkbox"
        name="acceptCookies"
        id="acceptCookies"
        #acceptCookies
        [attr.checked]="initialState.acceptCookies?.indexOf('true') !== -1 ? 'checked' : null"
        class="vc-form-checkbox-switch__input"
      />
      <label for="acceptCookies" class="vc-form-checkbox-switch__label" i18n="@@PRIVACY_POLICY.SETTINGS.OPTION_COOKIES"
        >Personalized content viewing whilst browsing</label
      >
    </div>
    <div class="vc-form-checkbox-switch">
      <input
        type="checkbox"
        name="acceptRetargeting"
        id="acceptRetargeting"
        #acceptRetargeting
        [attr.checked]="initialState.acceptRetargeting?.indexOf('true') !== -1 ? 'checked' : null"
        class="vc-form-checkbox-switch__input"
      />
      <label
        for="acceptRetargeting"
        class="vc-form-checkbox-switch__label"
        i18n="@@PRIVACY_POLICY.SETTINGS.OPTION_RETARGETING"
        >Targeted ads</label
      >
    </div>
    <div class="vc-form-checkbox-switch">
      <input
        type="checkbox"
        name="acceptAnalytics"
        id="acceptAnalytics"
        #acceptAnalytics
        [attr.checked]="initialState.acceptAnalytics?.indexOf('true') !== -1 ? 'checked' : null"
        class="vc-form-checkbox-switch__input"
      />
      <label
        for="acceptAnalytics"
        class="vc-form-checkbox-switch__label"
        i18n="@@PRIVACY_POLICY.SETTINGS.OPTION_ANALYTICS"
        >Website statistics</label
      >
    </div>

    <button
      class="vc-btn vc-btn--medium vc-btn--primary privacyPolicy__settingsSubmit"
      (click)="setUserChoices($event)"
      i18n="@@PRIVACY_POLICY.SETTINGS.SUBMIT"
    >
      Save Settings
    </button>
  </form>
</div>
